// extracted by mini-css-extract-plugin
export default {"selectBox":"DropDownCmp_selectBox__jnBKv","requiredAsterisk":"DropDownCmp_requiredAsterisk__FB47W"};